import React from 'react';
import { Clock } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function OpeningHook() {
  return <section className="py-10 bg-slate-800/30 border-y border-slate-800 relative" data-id="element-522">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-523">
        <ScrollFadeIn data-id="element-524">
          <div className="flex justify-center mb-8" data-id="element-525">
            <div className="w-16 h-16 rounded-full bg-slate-800 flex items-center justify-center border border-slate-700" data-id="element-526">
              <Clock className="w-8 h-8 text-amber-500" data-id="element-527" />
            </div>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-528">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-slate-50 mb-8 leading-snug" data-id="element-529">
            It’s 3:14 AM. You’re wide awake, your heart is thumping against your
            ribs, and your mind is racing through a mental Rolodex of tomorrow's
            "to-do" list.
          </h2>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.3} data-id="element-530">
          <p className="text-lg md:text-xl text-slate-300 text-center leading-relaxed" data-id="element-531">
            You feel physically exhausted, yet your internal engine is revving
            at 7,000 RPM. You’ve tried the diets and the "intense" workouts, but
            the only thing changing is the scale going up and your energy going
            down.
          </p>
        </ScrollFadeIn>
      </div>
    </section>;
}